import { Controller, useForm } from "react-hook-form";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updEventData } from "../../../../ReduxSlice/Event/eventSlice";
import MainComponentWrapper from "../../../Common/MainComponentWrapper";
import { EventById } from "../../../../utils/ApiConstant";
import SettingsTab from "./SettingsTab";
import Input from "./../../../UiElement/FormElement/Input";
import { useEffect, useState } from "react";
import useHttpHook from "../../../../Hooks/HttpHook";
import { refundPolicy, updateSettings } from "../../../../utils/ApiConstant";
import { RefundSettingsLanguage } from "../../../../utils/SettingsLanguages";
import SubmitButtonGroup from "../../../UiElement/FormElement/SubmitBtnGroup";
import { toast } from "react-toastify";
import { ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import { Form, Button } from "react-bootstrap";
import { showErrorToast } from "../../../../utils/notify";

const Settings = () => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    control,
    formState: { errors },
    reset,
  } = useForm({});
  const [refundPolicies, setRefundPolicies] = useState([]);

  const [loading, sendRequest, error] = useHttpHook();
  const { eventId } = useParams();
  const navigate = useNavigate();
  const {
    SettingForm,
    PromoterSetting,
    ServiceFeeSetting,
    AllowSplitPaymentSetting,
  } = RefundSettingsLanguage;
  const settingsData = useSelector((state) => state.event);
  const dispatch = useDispatch();

  useEffect(() => {
    if (settingsData.status) {
      showingFormData();
    }
  }, [settingsData]);

  useEffect(() => {
    getRefundPolicy();
    if (!settingsData.status) {
      getEventData();
    }
  }, []);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);

  const showingFormData = () => {
    reset({
      displayNoOfTicket: settingsData.data.settings.settings?.displayNoOfTicket,
      refundSettings: settingsData.data.settings.settings?.refundSettings,
      commissionAmount: settingsData.data.settings.settings?.commissionAmount,
      serviceFee: settingsData.data.settings.settings?.serviceFee,
      splitPaymentEnabled:
        settingsData.data.settings.settings?.splitPaymentEnabled,
      minSplitOrderAmount:
        settingsData.data.settings.settings?.minSplitOrderAmount,
    });
  };

  const getEventData = async () => {
    const event = await sendRequest(EventById + eventId);
    dispatch(updEventData(event));
  };

  const getRefundPolicy = async () => {
    const refundPolicyList = await sendRequest(refundPolicy, { method: "get" });
    setRefundPolicies(refundPolicyList.data);
  };

  const onSubmit = async (data) => {
    if (data.serviceFee == 0 || data.serviceFee == "0") {
      toast.error("Service fee is required");
      return;
    }
    const updateSetting = await sendRequest(updateSettings + eventId, {
      method: "post",
      data,
    });
    if (updateSetting.status === 1) {
      dispatch(updEventData(updateSetting));
      if (data.serviceFee !== 0) {
        navigate(`/myEvents/${eventId}/settings/instructions`, {
          replace: true,
        });
      }
    }
  };

  const isSplitPaymentEnabled = watch("splitPaymentEnabled");
  return (
    <MainComponentWrapper Loading={loading} errorInfo={error}>
      <div className="evntFormUI">
        <form
          className="event-create-form event-settings-form"
          onSubmit={handleSubmit(onSubmit)}
        >
          <SettingsTab Id="settings" />

          <div className="event-settings-panel">
            <section
              className="event-settings-section"
              aria-labelledby="eventSettingsDisplayTitle"
            >
              <h2
                className="event-settings-section-title"
                id="eventSettingsDisplayTitle"
              >
                {SettingForm.DisplaySettingsText}
              </h2>
              <div className="event-settings-box">
                <Input
                  Id="disPlaySettings"
                  WrapperClass="event-settings-checkbox"
                  LabelCls="event-settings-checkbox-label"
                  LabelPosition="bottom"
                  element="checkbox"
                  CustomFormGroupCls="event-settings-checkbox-group"
                  InputClassName="event-settings-checkbox-input"
                  Register={register}
                  Errors={errors}
                  FieldName="displayNoOfTicket"
                  LabelHtml={SettingForm.FormLabal.DisplaySettings.labelHtml}
                />
              </div>
            </section>

            <section
              className="event-settings-section"
              aria-labelledby="eventSettingsRefundTitle"
            >
              <h2
                className="event-settings-section-title is-accent"
                id="eventSettingsRefundTitle"
              >
                {SettingForm.RefundSettingsText}
              </h2>
              <h3 className="event-settings-subtitle">
                {SettingForm.RefundPolicyText}
              </h3>
              <p className="event-settings-note">{SettingForm.RefundSubHeading}</p>
              <div
                className="event-settings-radio-list"
                role="radiogroup"
                aria-label="Refund policy"
              >
                {refundPolicies?.map((policy, index) => (
                  <Input
                    key={index}
                    defValue={policy.value}
                    Id={`refund-${index}`}
                    WrapperClass="event-settings-radio"
                    LabelCls="event-settings-radio-label"
                    LabelPosition="bottom"
                    element="radio"
                    CustomFormGroupCls="event-settings-radio-group"
                    InputClassName="event-settings-radio-input"
                    Register={register}
                    Errors={errors}
                    FieldName="refundSettings"
                    Label={policy.policyDescription}
                  />
                ))}
              </div>
            </section>

            <section
              className="event-settings-section"
              aria-labelledby="eventSettingsPromoterTitle"
            >
              <h2
                className="event-settings-section-title"
                id="eventSettingsPromoterTitle"
              >
                {PromoterSetting}
              </h2>
              <Input
                element="number"
                FieldName="commissionAmount"
                Register={register}
                Errors={errors}
                placeholder="Commission Amount (%)"
                Label="Commission Amount (%)"
                CustomFormGroupCls="event-create-field"
                InputClassName="event-create-input"
              />
              <p className="event-settings-note">
                Promoter commission will transfer to them when tickets are
                purchased. (note: if tickets has the refund policy then
                commission will transfer after expiration of refund policy)
              </p>
            </section>

            <section
              className="event-settings-section"
              aria-labelledby="eventSettingsServiceFeeTitle"
            >
              <h2
                className="event-settings-section-title event-create-label-required"
                id="eventSettingsServiceFeeTitle"
              >
                {ServiceFeeSetting}
              </h2>
              <Input
                ValidationArr={[
                  { Type: "required", message: "Service Fee is required" },
                ]}
                element="number"
                FieldName="serviceFee"
                Register={register}
                Errors={errors}
                placeholder="Service Fee (USD)"
                CustomFormGroupCls="event-create-field"
                InputClassName="event-create-input"
              />
            </section>
              {/* <p>
                Promoter commission will transfer to them when tickets are
                purchased. (note: if tickets has the refund policy then
                commission will transfer after expiration of refund policy)
              </p> */}
            </div>
            <div className="event-settings-split-panel">
              <div className="event-settings-split-inner">
                <div className="event-settings-split-head">
                  <h4 className="event-settings-split-title">Allow Split Payments</h4>
                  <Controller
                    control={control}
                    name="splitPaymentEnabled"
                    render={({ field: { onChange, value, ref } }) => (
                      <Form.Check
                        className="event-settings-split-switch"
                        type="switch"
                        id="emi-toggle"
                        value={value}
                        ref={ref}
                        onChange={(e) => onChange(e.target.checked)}
                        checked={!!value}
                      />
                    )}
                  />
                </div>

                <p className="event-settings-split-help">
                  Enable this option to allow buyers to purchase tickets using
                  Split Payment.
                </p>
                <Controller
                  control={control}
                  name="splitPaymentEnabled"
                  render={({ field: { onChange, value } }) => (
                    <div
                      className="event-settings-split-options"
                      role="radiogroup"
                      aria-label="Split payment options"
                    >
                      <label
                        className={`event-settings-split-choice${
                          !value ? " is-active" : ""
                        }`}
                      >
                        <input
                          className="event-settings-split-choice-input"
                          type="radio"
                          name="emiOption"
                          checked={!value}
                          onChange={() => onChange(false)}
                        />
                        <span className="event-settings-split-choice-label">
                          Split Payment Disabled - Tickets must be paid in full
                        </span>
                      </label>
                      <label
                        className={`event-settings-split-choice${
                          value ? " is-active" : ""
                        }`}
                      >
                        <input
                          className="event-settings-split-choice-input"
                          type="radio"
                          name="emiOption"
                          checked={!!value}
                          onChange={() => onChange(true)}
                        />
                        <span className="event-settings-split-choice-label">
                          Split Payment Enabled - Buyers can purchase tickets in
                          multiple payments.
                        </span>
                      </label>
                    </div>
                  )}
                />
              </div>
              <p className="event-settings-split-note">
                An additional $0.30 cent will be charged per transaction for
                Split Payment. You can set the minimum order amount for Split
                Payment below.
              </p>
              {isSplitPaymentEnabled && (
                <div className="event-settings-split-min">
                  <h4>Minimum Order Amount for Split Payment</h4>
                  <Input
                    ValidationArr={[
                      {
                        Type: "required",
                        message: "Minimum Order Amount is required",
                      },
                      {
                        Type: "min",
                        message: "Minimum Order Amount is required",
                        minLength: {
                          value: 1,
                          message: "Minimum 1 Characters required",
                        },
                      },
                    ]}
                    FieldLabel="Minimum Order Amount"
                    element="number"
                    FieldName="minSplitOrderAmount"
                    Register={register}
                    Errors={errors}
                    placeholder="Minimum Order Amount (USD)"
                    // Label="Service Fee ($)"
                    InputClassName="col-md-4"
                    min={1}
                  />
                </div>
              )}
            </div>

          <SubmitButtonGroup
            GroupClassName="event-settings-footer"
            HideCancelBtn={true}
            isLoading={loading}
          />
        </form>
      </div>
    </MainComponentWrapper>
  );
};

export default Settings;
